import {Anchor, Badge, Group, Paper, Stack, Text} from '@mantine/core'
import {Link} from '@tanstack/react-router'

import {
    AssignmentStrip,
    PLANNED_ASSIGNMENT_STRIP_LEGEND_LABELS,
} from 'src/assignments/assignment-strip'
import {FORWARD_5_DAY_ASSIGNMENT_STRIP_DATE_RANGE} from 'src/assignments/assignment-strip-utils'
import {formatDeploymentStatusLabel} from 'src/equipment-deployment/format-deployment-status-label'
import {deploymentStatusColor} from 'src/theme/semantic-colors'

import type {FleetDeploymentStatus, FleetUnit} from './schemas'

type RentalAssetTypeFleetUnitCardProps = {
    unit: FleetUnit
    referenceDate: Date
}

function deploymentBadgeColor(status: FleetDeploymentStatus['status']) {
    return deploymentStatusColor(status)
}

function FleetDeploymentBadge({status}: {status: FleetDeploymentStatus}) {
    return (
        <Badge color={deploymentBadgeColor(status.status)} variant="light" size="sm">
            {formatDeploymentStatusLabel(status)}
        </Badge>
    )
}

export function RentalAssetTypeFleetUnitCard({
    unit,
    referenceDate,
}: RentalAssetTypeFleetUnitCardProps) {
    const unitName = unit.name ?? 'Unnamed unit'

    return (
        <Paper withBorder p="md" radius="md" data-testid={`fleet-unit-card-${unit.id}`}>
            <Stack gap="md">
                <Group justify="space-between" align="center" wrap="nowrap">
                    <Group gap="xs" wrap="nowrap" style={{minWidth: 0, flex: 1}}>
                        <Text fw={600} truncate>
                            {unitName}
                        </Text>
                        <FleetDeploymentBadge status={unit.deploymentStatus} />
                    </Group>
                    <Anchor
                        component={Link}
                        to="/rental-assets/$assetId"
                        params={{assetId: unit.id}}
                        size="sm"
                        style={{flexShrink: 0}}
                    >
                        View full details
                    </Anchor>
                </Group>

                <AssignmentStrip
                    assignments={unit.upcomingAssignments}
                    referenceDate={referenceDate}
                    title="Planned assignments"
                    dateRange={FORWARD_5_DAY_ASSIGNMENT_STRIP_DATE_RANGE}
                    presentation="schedule"
                    legendLabels={PLANNED_ASSIGNMENT_STRIP_LEGEND_LABELS}
                    embedded
                    showLegend={false}
                />
            </Stack>
        </Paper>
    )
}
